import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// import { Link } from 'react-router-dom';
import logo from 'assets/img/illustrations/falcon.png';

const LogoNavbar = ({ at, width, className, textClass, ...rest }) => {
  return (
    <div
      className={classNames(
        'text-decoration-none',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="me-2" src={logo} alt="Logo" width={width} />
        <span className={classNames('font-sans-serif')} style={{color:'#5e6e82',fontSize:'18px',fontWeight:'normal'}}>FIDA Helpdesk</span>
      </div>
    </div>
  );
};

LogoNavbar.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

LogoNavbar.defaultProps = { at: 'auth', width: 58 };

export default LogoNavbar;
